import React, { useState } from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';

const faqs = [
  {
    question: 'What types of corporate travel services does eTravo offer?',
    answer:
      'eTravo specializes in providing tailored corporate travel solutions including airport transfers, outstation business trips, employee transportation, and daily office commute services using premium cabs, buses, and tempo travellers.',
  },
  {
    question: 'How can my company book a travel service with eTravo?',
    answer:
      'You can easily book travel services with eTravo through our website, mobile app, or by contacting our dedicated corporate support team. We offer instant confirmations, billing support, and fleet availability updates in real time.',
  },
  {
    question: 'Does eTravo provide invoice and billing support for corporates?',
    answer:
      'Yes, we provide GST-compliant invoicing and detailed monthly billing support for all corporate clients. You can choose from multiple payment modes and request trip-wise or consolidated reports for easier accounting.',
  },
  {
    question: 'Can I schedule recurring trips for employees with eTravo?',
    answer:
      'Yes, eTravo allows companies to schedule recurring employee pickup and drop services. You can customize timings, locations, and vehicle types as per your daily commute or shift requirements.',
  },
  {
    question: 'What safety measures does eTravo follow during corporate trips?',
    answer:
      'All eTravo vehicles are sanitized regularly, and our drivers are trained in hygiene protocols. We also provide real-time trip tracking, SOS alerts, and verified driver IDs to ensure maximum safety.',
  },
];

const FaqsSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFaq = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <>
      <section
        className="page-title"
        style={{
          backgroundImage: 'url(images/background/3.jpg)',
          color: '#fff',
          textAlign: 'center',
          padding: '3rem 0',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          fontWeight: '700',
          textTransform: 'uppercase',
          letterSpacing: '2px',
          borderBottom: '4px solid #096C05',
        }}
      >
        <div className="auto-container">
          <h1 style={{ color: '#096C05', fontSize: '3rem' }}>FAQs</h1>
        </div>
      </section>

      <div className="faqs-section" style={{ padding: '3rem 0', backgroundColor: '#f9fdf7' }}>
        <div className="auto-container" style={{ maxWidth: '900px', margin: '0 auto' }}>
          <ul className="accordion-box" style={{ listStyleType: 'none', padding: 0 }}>
            {faqs.map((faq, index) => (
              <li
                key={index}
                className={`accordion block ${activeIndex === index ? 'active' : ''}`}
                style={{
                  border: '1px solid #096C05',
                  borderRadius: '8px',
                  marginBottom: '1rem',
                  boxShadow: activeIndex === index ? '0 4px 12px rgba(9,108,5,0.3)' : 'none',
                  transition: 'box-shadow 0.3s ease',
                }}
              >
                <div
                  className="acc-btn"
                  onClick={() => toggleFaq(index)}
                  style={{
                    cursor: 'pointer',
                    padding: '1rem 1.5rem',
                    backgroundColor: activeIndex === index ? '#096C05' : '#e2f0d9',
                    color: activeIndex === index ? '#fff' : '#096C05',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    fontSize: '1.1rem',
                    borderRadius: '8px',
                    userSelect: 'none',
                  }}
                >
                  <span>{faq.question}</span>
                  <span className="icon icon-plus" style={{ marginLeft: '1rem', fontSize: '1.2rem' }}>
                    <i className={`fas ${activeIndex === index ? 'fa-angle-up' : 'fa-angle-down'}`}></i>
                  </span>
                </div>

                {activeIndex === index && (
                  <div
                    className="acc-content current"
                    style={{
                      padding: '1rem 1.5rem',
                      backgroundColor: '#f0f9e8',
                      color: '#096C05',
                      fontSize: '1rem',
                      borderTop: '1px solid #096C05',
                      borderRadius: '0 0 8px 8px',
                      lineHeight: '1.5',
                    }}
                  >
                    <p>{faq.answer}</p>
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default FaqsSection;
